<div class="g-modal-v2 reset-password-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'global.change_password' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <div class="g-modal-v2-content">

    @if (state() === 'select-login') {
      @if (hasBothEmailAndPhoneNumber()) {
        @let customer = customerService.customer();
        <div class="reset-password-title">
          {{ 'reset_password_modal.select_login' | translate }}
        </div>

        <div class="login-option">
          <tc-form-radio-input
            inputId="login-type-email"
            inputName="login-type"
            [inputValue]="customer?.contactInfo.email"
            [inputFormControl]="loginControl"
          >
            <div class="login-label">
              <tc-icon
                class="login-icon"
                name="email"
              />
              <div class="login-text">
                {{ 'reset_password_modal.to_email' | translate }} <b>{{ customer?.contactInfo.email }}</b>
              </div>
            </div>
          </tc-form-radio-input>
        </div>

        <div class="login-option">
          <tc-form-radio-input
            inputId="login-type-phone"
            inputName="login-type"
            [inputValue]="customer?.contactInfo.phoneNumber"
            [inputFormControl]="loginControl"
          >
            <div class="login-label">
              <tc-icon
                class="login-icon"
                name="phone"
              />
              <div class="login-text">
                {{ 'reset_password_modal.to_phone' | translate }} <b>{{ customer?.contactInfo.phoneNumber | mask:PHONE_NUMBER_MASK }}</b>
              </div>
            </div>
          </tc-form-radio-input>
        </div>

        @if (error()) {
          <div class="g-form-error">
            {{ error() }}
          </div>
        }

        <tc-button
          class="reset-password-submit"
          (click)="state.set('otp')"
          buttonSize="large"
          buttonType="submit"
        >
          {{ 'global.send_otp' | translate }}
        </tc-button>
      } @else if (loginControl.invalid) {
        <div class="no-logins">
          {{ 'reset_password_modal.no_logins' | translate }}
        </div>
      }

    } @else {
      <tc-reset-password
        [login]="loginControl.getRawValue()"
        (success)="dialogRef.close('CONFIRM')"
      >
      </tc-reset-password>
    }
  </div>
</div>
